import { COUNTRIES } from '@retracedgmbh/modules/countries/contracts';

// The shared country list, as a mutable copy sorted by English name — the
// order this file's consumers have always seen (`lib/constants.js` sorts it in
// place at load, which the frozen shared list would not allow).
export default [...COUNTRIES].sort((a, b) =>
  a.countryNameEn.localeCompare(b.countryNameEn),
);
